// import React from 'react';
import { styled } from '@mui/material/styles';
import { SdgScoreClobDto } from 'models/dtoTypes';
import SubSection from './_subSection';
import SdgScoreClob, { ISdgData } from './_sdgScoreClob';
import Empty from './_empty';
import { generateSdgIcon } from 'kosmos/images';
import { sdgLogo } from 'kosmos/images';
import EsgLegand from './_esgLegand';
import { useTranslation } from 'react-i18next';

const PREFIX = '_sdgReport';

const classes = {
  report: `${PREFIX}-report`,
  sdgContainer: `${PREFIX}-sdgContainer`,
};

const Root = styled('div')(() => ({
  position: 'relative',
  width: '100%',
  [`& .${classes.report}`]: {},
  [`& .${classes.sdgContainer}`]: {
    position: 'relative',
    height: 55,
    '& .sdg-icon': {
      position: 'absolute',
      height: '100%',
    },
    '& .sdg-item': {
      marginLeft: 70,
    },
  },
}));

interface IProps {
  name?: string;
  sdgReport: SdgScoreClobDto[];
}

export default function IndicativeRegulatoryReport(props: IProps): JSX.Element {
  const { sdgReport } = props;
  const { t } = useTranslation('default');

  const renderSingleClob = (item: SdgScoreClobDto, index: number) => {
    const { title, sdgNumber, iccDimension, affinity } = item;
    const key = title ? title.toString().replace(/\W/g, '-').toLowerCase() : '';
    return (
      <div key={index} className={classes.sdgContainer}>
        <div className="sdg-icon">
          <img src={generateSdgIcon(index + 1)} height="100%" />
        </div>
        <div className="sdg-item">
          <SdgScoreClob
            sdgId={`${key}-content`}
            anchor={`${key}-appendix`}
            itemNumber={sdgNumber}
            title={title || ''}
            iccDimension={iccDimension}
            affinity={affinity}
            withBorder={true}
            withBg={true}
          />
        </div>
      </div>
    );
  };

  const renderLegands = () => {
    const legands: ISdgData[] = [
      {
        affinity: 'negative',
        title: t('business-activity-found-to-be-associated-with-sdg-negative-impact-identified'),
        withBg: true,
        size: 'small',
      },
      {
        affinity: 'positive',
        title: t('business-activity-found-to-be-associated-with-sdg-no-negative-impact'),
        withBg: true,
        size: 'small',
      },
      {
        affinity: 'neutral',
        title: t('no-business-activity-found-to-be-associated-with-sdg'),
        withBg: true,
        size: 'small',
      },
    ];

    return (
      <EsgLegand
        legands={legands}
        title={t('activity-check-against-united-nations-sustainable-development-goals-sdgs')}
        learnMoreTabId="sdg"
      />
    );
  };

  const renderContent = () => {
    if (sdgReport.length === 0) {
      return <Empty title={t('there-is-no-data-available')} />;
    }

    return (
      <Root>
        <SdgScoreClob iccDimension={t('icc-dimension')} />
        {sdgReport.map(renderSingleClob)}
      </Root>
    );
  };

  return (
    <SubSection>
      <>
        <img src={sdgLogo} width="400" />
        {renderLegands()}
        {renderContent()}
      </>
    </SubSection>
  );
}
